export const AGENDA_SOLUTION_CONSTANT = {
  // テーブル名
  TABLE: 'agenda_solution',
  // csvファイル名
  CSV_FILENAME: 'agenda-solution',
};
